import React from 'react';
import { NextSeo } from 'next-seo';
import { terms_and_conditions } from '@apps/data/terms_and_conditions';

const terms = () => {
  const metaTitle = "Terms and Conditions - Alchemis";
  const metaDesc = ` We collect certain data from you directly like information
  you enter yourself data about your participation in courses
  and data from third-party platforms you connect with Webby.
  We also collect some data automatically information about
  your device and what parts of our Services you interact with
  or spend time using.`;
  const metaImg = `/images/meta/general.png`;
	return (
		<div>
      <NextSeo
        title={metaTitle}
        description={metaDesc}
        openGraph={{
          title: `${metaTitle}`,
          description: `${metaDesc}`,
          images: [
            {
              url: `${metaImg}`,
            }
          ]
        }}
      />
			<div className="pt-[5.5rem] lg:pt-24">
				{/* <!-- TOS --> */}
				<section className="dark:bg-jacarta-800 relative py-16 md:py-24">
					<div className="container">
						<h1 className="font-display text-jacarta-700 mx-auto max-w-[48.125rem] text-4xl font-medium dark:text-white">
							Terms and Conditions
						</h1>
            <div className="divide-y">
              <div className="article-content mx-auto pb-10 max-w-[48.125rem]">
                <p>These Terms and Conditions ("Terms") set forth the agreement between you and Alchemis governing your use of the services provided by Alchemis and the website located at <a class='underline inline-block' href='https://www.alchemis.com/'>https://www.alchemis.com/</a> (referred to herein as the "Website"). By accessing or using the Website, you acknowledge that you have read, understood, and agree to be bound by these Terms. You must not use this website, if you have any objection to any of these Terms and Conditions.</p>
                <p>Please read these Terms and Conditions carefully before using this website.</p>
              </div>
              {terms_and_conditions.map((value, i) => {
                return (
                  <div key={i} className="article-content mx-auto pb-10 max-w-[48.125rem]">
                    <h2 className={'text-2xl font-display !font-semibold'}>{value?.title}</h2>
                    {value?.description?.map((val, index) => (
                      <p key={index}>{val}</p>
                    ))}
                    {value?.subContent?.map((sub) => {
                      return (
                        <>
                          <h3 className={'text-md font-display !font-medium'}>{sub.title}</h3>
                          <p>{sub.description}</p>
                        </>
                      )
                    })}
                  </div>
                )
              })}
            </div>
            <div className="article-content mx-auto pb-10 max-w-[48.125rem]">
              <p>Please contact us at <a href="mailto:info@alchemis.com" className="underline">info@alchemis.com</a> if you have any questions or concerns regarding these Terms and Conditions.</p>
            </div>
					</div>
				</section>
				{/* <!-- end TOS --> */}
			</div>
		</div>
	);
};

export default terms;
